import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAuthContext } from "../hooks/useAuthContext";
import {
  BLOG_BASE_URL,
  BLOG_BASE_URL_LOCAL_HOST,
} from "../services/blogService";
import axios from "axios";
import { set } from "date-fns";

const BlogUpdate = () => {
  const url = BLOG_BASE_URL || BLOG_BASE_URL_LOCAL_HOST;

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [imageError, setImageError] = useState(false);

  const [previewImage, setPreviewImage] = useState();
  const [openSnackbar, setOpenSnackbar] = useState(false);

  const [alertMessage, setAlertMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("success");
  const navigate = useNavigate();
  const { id } = useParams();
  const { user } = useAuthContext();

  const [blog, setBlog] = useState({
    title: "",
    blogImage: "",
    summary: "",
    description: "",
    facebookLink: "",
    linkedInLink: "",
    githubLink: "",
    author: "",
    createdAt: new Date(),
  });

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setPreviewImage(URL.createObjectURL(file)); // Set preview URL for the image
      setBlog({
        ...blog,
        blogImage: file, // Set the file object in state for upload
      });
    } else {
      setPreviewImage(null); // Clear preview if no file is selected
      setBlog({
        ...blog,
        blogImage: "",
      });
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setBlog({
      ...blog,
      [name]: value,
    });
  };
  // Function to properly format the image URL
  const getImageUrl = (imagePath) => {
    if (!imagePath) return "";
    // Remove any leading dots or slashes and ensure proper path formatting
    const cleanPath = imagePath.replace(/^\.\.\//, "").replace(/^\//, "");
    return `${BLOG_BASE_URL}/${cleanPath}`;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const token = localStorage.getItem("token");

    const data = new FormData();
    data.append("title", blog.title);
    data.append("summary", blog.summary);
    data.append("description", blog.description);
    data.append("author", blog.author);
    data.append("facebookLink", blog.facebookLink);
    data.append("linkedInLink", blog.linkedInLink);
    data.append("githubLink", blog.githubLink);
    data.append("blogImage", blog.blogImage);

    try {
      const response = await axios.put(`${url}/api/blogs/update/${id}`, data);
      navigate(`/api/blogs`);
    } catch (error) {
      setError(error.response?.data?.message || "Something went wrong!");
    } finally {
      setLoading(false);
    }
  };

  const fetchBlogData = async () => {
    try {
      const response = await axios.get(`${BLOG_BASE_URL}/api/blogs/list/${id}`);
      setBlog(response.data);
    } catch (error) {
      setError(error.response?.data?.message || "Unable to fetch blog data!");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBlogData();
  }, [id]);
  console.log("blog:", blog.title);
  return (
    <>
      <section className="update-blog">
        <div className="container mt-3">
          {error && <div className="alert alert-danger">{error}</div>}

          <div className="row bg-white p-3">
            <div className="col">
              <h1 className="p-3">Add New Blog</h1>
              <hr />
              <p className="lead">
                Please provide the new blog details in the form below.
              </p>
              {/*  onSubmit={handleSubmit} */}
              <form onSubmit={handleSubmit}>
                <div className="mb-4">
                  <input
                    type="text"
                    className="form-control form-control-lg"
                    name="title"
                    // value={formData.title}
                    value={blog.title}
                    placeholder="Title"
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="mb-4">
                  <input
                    type="text"
                    className="form-control form-control-lg"
                    name="summary"
                    value={blog.summary}
                    placeholder="Summary"
                    onChange={handleChange}
                    required
                  />
                </div>
                {/* Author */}

                <div className="mb-4">
                  <input
                    type="text"
                    className="form-control form-control-lg"
                    name="author"
                    value={blog.author}
                    placeholder="author"
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="mb-4">
                  <textarea
                    name="description"
                    value={blog.description}
                    className="form-control form-control-lg"
                    placeholder="Description"
                    onChange={handleChange}
                    rows={10}
                    required
                  ></textarea>
                </div>

                {/* Facebook */}

                <div className="mb-4">
                  <div className="input-group has-validation">
                    <span className="input-group-text" id="inputGroupPrepend">
                      <i className="fa fa-facebook" aria-hidden="true"></i>{" "}
                    </span>
                    <input
                      name="facebookLink"
                      value={blog.facebookLink}
                      className="form-control form-control-lg"
                      placeholder="facebook link"
                      onChange={handleChange}
                    />
                  </div>
                </div>

                {/* LinkedIn */}
                <div className="mb-4">
                  <div className="input-group has-validation">
                    <span className="input-group-text" id="inputGroupPrepend">
                      <i className="fa fa-linkedin" aria-hidden="true"></i>{" "}
                    </span>
                    <input
                      type="text"
                      className="form-control form-control-lg"
                      name="linkedInLink"
                      value={blog.linkedInLink}
                      placeholder="linkedIn link"
                      onChange={handleChange}
                    />
                  </div>
                </div>

                {/* Github */}

                <div className="mb-4">
                  <div className="input-group has-validation">
                    <span className="input-group-text" id="inputGroupPrepend">
                      <i className="fa fa-github" aria-hidden="true"></i>
                    </span>
                    <input
                      type="text"
                      className="form-control form-control-lg"
                      name="githubLink"
                      value={blog.githubLink}
                      placeholder="github link"
                      onChange={handleChange}
                    />
                  </div>
                </div>
                {/* Show image */}
                {blog.blogImage && (
                  <img
                    src={blog.blogImage || getImageUrl(blog.blogImage)}
                    name="blogImage"
                    value={blog.blogImage}
                    onChange={handleChange}
                    alt={blog.title || "Blog Image"}
                    style={{
                      width: "300px",
                      height: "150px",
                      objectFit: "cover",
                    }}
                  />
                )}

                {/* Image Preview */}
                <div className="mb-4">
                  {previewImage && (
                    <img
                      src={previewImage || getImageUrl(blog.blogImage)}
                      alt={blog.title || "Blog Image Preview"}
                      style={{
                        width: "100px",
                        height: "100px",
                        objectFit: "cover",
                      }}
                    />
                  )}

                  {/* Image Upload */}
                  <input
                    type="file"
                    className="form-control form-control-lg"
                    name="blogImage"
                    id="blogImage"
                    accept="image/*"
                    onChange={handleImageChange}
                  />
                </div>

                <div className="d-gridxx gap-2xx">
                  <button
                    type="submit"
                    className="btn btn-outline-primary mt-2 fw-bold btn-lg btn-block"
                    disabled={
                      loading ||
                      !blog.title ||
                      !blog.summary ||
                      !blog.description
                    }
                  >
                    {loading ? (
                      <>
                        <div
                          className="spinner-border spinner-border-sm me-3"
                          role="status"
                          aria-hidden="true"
                          style={{ width: "1.5rem", height: "1.5rem" }}
                        ></div>
                        <small
                          className="text-muted"
                          style={{ fontSize: "12px" }}
                        >
                          Please wait...
                        </small>
                      </>
                    ) : (
                      <div>SUBMIT</div>
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default BlogUpdate;
